import { render, staticRenderFns } from "./ServicePageLayout.vue?vue&type=template&id=f7845ba2"
import script from "./ServicePageLayout.vue?vue&type=script&lang=js"
export * from "./ServicePageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports